/** Card.tsx — passthrough wrapper around the design.css `.card` class. */
import React from 'react';

interface Props {
	title?: React.ReactNode;
	tools?: React.ReactNode;
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

export default function Card({ title, tools, children, className, style }: Props) {
	return (
		<section className={`card ${className ?? ''}`} style={style}>
			{(title || tools) && (
				<div className="card-head">
					{title && <div className="card-title">{title}</div>}
					{tools && <div className="card-tools">{tools}</div>}
				</div>
			)}
			{children}
		</section>
	);
}
